import { Carousel, Image, Card, Row, Col, Typography, Avatar, Divider } from 'antd';
import React from 'react';

const {Text, Title, Paragraph} = Typography;
const contentStyle = {
  height: '160px',
  color: '#fff',
  lineHeight: '160px',
  textAlign: 'center',
  background: '#364d79',
};

const About = () => {
    return (
    <>
    <Divider></Divider>
    <Row justify='center'><Col span={16}>
    <Card>
    <Carousel autoplay>
        <div>
        <Image
            src={process.env.PUBLIC_URL + "/asset/pictures/Image3.jpg"}
            height={500}
            width={800}
          />
        </div>
        <div>
        <Image
            src={process.env.PUBLIC_URL + "/asset/pictures/Image2.jpg"}
            height={500}
            width={800}
          />
        </div>
        <div>
        <Image
            src={process.env.PUBLIC_URL + "/asset/pictures/Image1.jpg"}
            height={500}
            width={800}
          />
        </div>

        <div>
        <Image
            src={process.env.PUBLIC_URL + "/asset/pictures/Image4.jpg"}
            height={500}
            width={800}
          />
        </div>

        <div>
        <Image
            src={process.env.PUBLIC_URL + "/asset/pictures/Image5.jpg"}
            height={500}
            width={800}
          />
        </div>
        <div>
        <Image
            src={process.env.PUBLIC_URL + "/asset/pictures/Image6.jpg"}
            height={500}
            width={800}
          />
        </div>
        
    </Carousel>
    </Card>
    </Col>
    <Col span={8}>
        <Card>
            <Title>Hello Visitor !</Title>
            <Avatar gap={20} shape='square' size={264} src={process.env.PUBLIC_URL + "/asset/pictures/Krishna.jpg"}>
            </Avatar>
            <Divider></Divider>
            <Paragraph>
                Welcome to my webpage . I am Krishna . I am a 27 year old Engineer/Photographer. I work as Devops Engineer (More on Professional Profile section), currently based in Bengaluru, India. When I am free I love to travel around and click pictures. 
                I like to talk about Technology, Photography , Nature and Space. On side are some of my Pictures that i clicked , For more follow me on instagram @cliqonrandom .  
            </Paragraph>
        </Card>
    </Col>
    </Row>
  </>
    )
};

export default About;